import versionInfo from "./version.json";

export const environment = {
  production: true,
  BASE_URL: "https://solicitudes-test.agd.com.ar/api-sol/",
  //BASE_URL: "http://127.0.0.1:3001/api-sol/",

  cookieDomain: ".solicitudes-test.agd.com.ar",
  version: `${versionInfo.version}@STAGE`,

  // reCAPTCHA V2 (mantener durante transición)
  reCaptchaKey: "6Le2lscoAAAAACwV1vv8_hi5UHSRqYCcTxg9G3GT",
  captcha: {
    sitekey: "6Ld6UtwrAAAAAOv_eDEQbJ5c7f2ftS7lhgmNGg8b",
  },
  disableCaptcha: false, // Habilitar captcha para testing

  // reCAPTCHA Enterprise (GCP) - Staging
  reCaptchaEnterprise: {
    enabled: true, // Habilitado para testing
    keyId: "6LeZEIcsAAAAAEh1hkoc06Q8MGL7Bdd5P4tYtEs2", // Clave proporcionada por el cliente
    projectId: "project-343de3fc-aedb-41ee-ba6",
    threshold: 0.3, // Más permisivo en stage para testing
    apiUrl: "https://www.google.com/recaptcha/enterprise.js",
    actions: {
      login: "LOGIN",
      recoverPassword: "RECOVER_PASSWORD",
      register: "REGISTER",
      contact: "CONTACT",
    },
  },
};
